// src/auth/session.js
import { getAccessToken, setAccessToken } from "../api/axiosAuth";

export function isAuthed() {
  // if you also mirror to localStorage, hydrate on first call:
  if (!getAccessToken()) {
    const saved = localStorage.getItem("accessToken");
    if (saved) setAccessToken(saved);
  }
  return !!getAccessToken();
}
